import React, { useEffect, useState, useCallback }  from 'react';
import { motion } from "framer-motion";
import { Row, Col } from 'react-bootstrap';

import "./index.scss";

import SkeletonLoader from "../../../../../ui/SkeletonLoader";
import NoDataFound from "../../../../../ui/NoDataFound";

import { useScanInfoContext } from "../../../../../../pages/ScanInfo/ScanInfoContext";

import { viewMoreDownArrowIcon } from "../../../../../../utils/icons";

import { useSelector, useDispatch } from 'react-redux';
import { getSSLStatusStats } from "../../../../../../store/actions/thirdPartyRiskAction";
import { formatNumber } from "../../../../../../utils/util";

const SSLStatusCard = () => {

    const sslStatusStatsResponse = useSelector((state) => state.thirdPartyRisk.sslVulnerabilitiesStats);
        
    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const dispatch = useDispatch();

    const [sslStatusStatsLoading, setSSLStatusStatsLoading] = useState(false);
    const [sslStatusStatsStats, setSSLStatusStatsStats] = useState(null);
    const [showViewAll, setShowViewAll] = useState(false)

    const fetchSSLStatusStats = useCallback(()=>{
        setSSLStatusStatsLoading(true)
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getSSLStatusStats(params))
    },[dispatch, organizationId, domainId, scanId])

    useEffect(()=>{
        if (triggerStatsFetch) {
            fetchSSLStatusStats();
            setTriggerStatsFetch(false);
        }
    },[triggerStatsFetch, setTriggerStatsFetch, fetchSSLStatusStats])

    useEffect(()=>{
        if(sslStatusStatsResponse !== null) {
            setSSLStatusStatsLoading(false);
            setSSLStatusStatsStats(sslStatusStatsResponse);
        }
    },[sslStatusStatsResponse])


    return (
        <div className="bg-white-with-shadow p-4 h-100">
            {
                sslStatusStatsLoading ?
                <SkeletonLoader type={"line"} count={4} />
                :
                <motion.div
                    className="h-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="d-flex justify-content-between mb-2 dashboard-box-container">
                        <p className="heading font-bold">SSL Vulnerabilities Status Card</p>
                    </div>
                    <div className={`vulnerabilities-status-card-container ${showViewAll ? "active" : ""}`}>
                        <Row>
                            {
                                sslStatusStatsStats?.stats?.ssl_vulnerabilities && Object.entries(sslStatusStatsStats?.stats?.ssl_vulnerabilities).length > 0 ?
                                Object.entries(sslStatusStatsStats?.stats?.ssl_vulnerabilities).map(([key, value], index) => {
                                    return (
                                        <Col lg={6} key={index}>
                                            <div className="vulnerability-card p-3 rounded">
                                                <p className="status-name">{key}</p>
                                                <p className="status-count">{formatNumber(value)}</p>
                                            </div>
                                        </Col>
                                    )
                                })
                                :
                                <NoDataFound noDataText={sslStatusStatsStats?.description} />
                            }
                        </Row>
                    </div>
                    {sslStatusStatsStats?.stats?.ssl_vulnerabilities && Object.entries(sslStatusStatsStats?.stats?.ssl_vulnerabilities).length > 4 && <div className="view-more-div d-flex align-items-center justify-content-center p-2">
                        <p className="m-0 cursor-pointer" onClick={()=>{setShowViewAll(!showViewAll)}}>{showViewAll ? "View Less" : "View More"} <span className={`${showViewAll ? "active" : ""}`}>{viewMoreDownArrowIcon()}</span></p>
                    </div>} 
                </motion.div>
            }                               
        </div>
    )
}

export default SSLStatusCard;